import { render, staticRenderFns } from "./LlmsText.vue?vue&type=template&id=4c2a7a35&"
import script from "./LlmsText.vue?vue&type=script&lang=ts&"
export * from "./LlmsText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports